export default class Stock {
    /** @type {String} */
    id = ''
    low_count = 0
    critical_count = 0
    sort = 0
    name = ''
    /** @type {Boolean} */
    is_public = true
    /** @type {Boolean} */
    is_virtual = false

    constructor(stock) {
        if (stock) {
            this.id = stock.id.toString()
            this.low_count = stock.low_count
            this.critical_count = stock.critical_count
            this.sort = stock.sort
            this.name = stock.name
            this.is_public = stock.is_public
            this.is_virtual = stock.is_virtual
        }
    }
}